import type { PropsWithChildren, ReactElement } from "react";

import EnrichmentErrorState from "app/pages/sales-intelligence/pages/enrichment/components/EnrichmentErrorState/EnrichmentErrorState";

import ErrorBoundaryWithLogging from "../../../../common-components/ErrorBoundaryWithLogging/ErrorBoundaryWithLogging";

import { StyledManagementPageContainer, StyledManagementPageWrapper, StyledScrollToTopWrapper } from "./styles";

interface IProps {
    className?: string;
}

const ManagementPageWrapper = ({ className, children }: PropsWithChildren<IProps>): ReactElement => {
    return (
        <StyledScrollToTopWrapper>
            <ErrorBoundaryWithLogging fallback={<EnrichmentErrorState />}>
                <StyledManagementPageContainer className={className}>
                    <StyledManagementPageWrapper
                        flexDirection="column"
                        gap="32px"
                    >
                        {children}
                    </StyledManagementPageWrapper>
                </StyledManagementPageContainer>
            </ErrorBoundaryWithLogging>
        </StyledScrollToTopWrapper>
    );
};

export default ManagementPageWrapper;
